// extracted by mini-css-extract-plugin
export default {"slideContainer":"TVX8J","slide":"asP6o"};